import React from 'react';

import { FilePickerItem, FilePickerItemControls, FilePickerItemSeparator, FilePickerFileName } from '../../styles';

import Button from '../../../Button/Button';
import Anchor from '../../../Anchor/Anchor';

type File = {
  pk: string;
  url: string;
};
export interface FilesListProps {
  files: any;
  handleDelete: (file: File) => void;
  disabled?: boolean;
}

function FilesList(props: FilesListProps) {
  const { files, handleDelete, disabled } = props;

  return files.map(file => (
    <FilePickerItem key={file.name}>
      <FilePickerItemControls>
        <Button
          onClick={e => {
            e.preventDefault();
            handleDelete(file);
          }}
          type="link"
          isDisabled={disabled}
        >
          Remove
        </Button>

        {Boolean(file.url) && (
          <>
            <FilePickerItemSeparator>|</FilePickerItemSeparator>
            <Anchor href={file.url} rel="noopener noreferrer" target="_blank" isDisabled={disabled}>
              View
            </Anchor>
          </>
        )}
      </FilePickerItemControls>

      <FilePickerFileName title={file.name}>{file.name}</FilePickerFileName>
    </FilePickerItem>
  ));
}

export default FilesList;
